import React from 'react';

import { Button, utils } from '@ergeon/core-components';
import { PhoneIcon } from '@ergeon/icons/hero/micro';

import { DEFAULT_PHONE } from './constants';
import { PhoneLinkProps } from './types';

const PhoneLink: React.FC<PhoneLinkProps> = ({ phoneNumber = DEFAULT_PHONE }) => {
  const { link, display } = utils.formatPhoneNumber(phoneNumber);

  return (
    <Button
      asAnchor
      data-track-call="true"
      flavor="warning"
      href={link}
      taste="boundless">
      <PhoneIcon className="size-4" />
      {display}
    </Button>
  );
};

export default PhoneLink;
